module.exports = __webpack_public_path__ + "img/solution30.9d36a273.png";